import { DateTime, Duration, DurationLikeObject } from 'luxon';
import { EntityCollectionService, QueryParams } from '@ngrx/data';
import { Observable } from 'rxjs';
import { Dictionary } from '@ngrx/entity';
import { InjectionToken } from '@angular/core';

export type Age = DateTime | Duration | DurationLikeObject | number | string;

export const ENTITY_SERVICE = new InjectionToken('ENTITY_SERVICE');

export interface EntityService {
  getEcs<T>(entityName: string): EntityCollectionService<T>;

  add<T>(entityName: string, entity: T): Observable<T>;

  entities$<T>(entityName: string): Observable<T[]>;

  entityMap$<T>(entityName: string): Observable<Dictionary<T>>;

  load<T>(entityName: string): Observable<T[]>;

  loadIfOlderThan<T>(
    entityName: string,
    age: Age,
    maxPages?: number,
  ): Observable<T[]>;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getWithQueryIfOlderThan<T>(
    entityName: string,
    query: QueryParams,
    age?: Age,
  ): Observable<T[]>;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getWithQuery<T>(entityName: string, query: QueryParams, ignoreGlobalFilter?: boolean): Observable<T[]>;

  selectEntitiesAndLoadIfOlderThan<T>(
    entityName: string,
    age?: Age,
  ): Observable<T[]>;

  loadEntitiesModifiedSinceLastLoad(
    entityName: string,
  ): void;

  selectEntityMapAndLoadIfOlderThan<T>(
    entityName: string,
    age?: Age,
  ): Observable<Dictionary<T>>;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getTimeLastLoaded<T>(entityName: string): Observable<string>;

  getEntitiesModifiedSinceOrLoadIfOlderThan<T>(
    entityName: string,
    age: Age,
    maxPages?: number,
  ): Observable<T[]>;
}
